import type { PerspectiveCamera } from "three";
import type { CameraController } from "../../types/camera";
import type { ReadonlyInputState } from "../../types/input";

/**
 * Porte la caméra et délègue son pilotage au contrôleur courant.
 * Changer de mode de caméra ne touche que cette classe et le contrôleur.
 */
export class CameraRig {
  private current: CameraController | null = null;

  constructor(readonly camera: PerspectiveCamera) {}

  /** Le rig devient propriétaire du contrôleur : il libère le précédent. */
  setController(controller: CameraController | null): void {
    this.current?.dispose();
    this.current = controller;
  }

  update(input: ReadonlyInputState, dt: number): void {
    this.current?.update(input, dt);
  }

  dispose(): void {
    this.current?.dispose();
    this.current = null;
  }
}
